export const Denmark = {
    name: "Denmark",
    image: "/Denmark.jpg",
    overview: {
        title: "Why Bangladeshi Students Choose Denmark for Higher Studies?",
        descriptions: [
            "Bangladeshi students choose Denmark for its innovative education system, high-quality research opportunities, and excellent work-life balance. The country offers free education for EU/EEA students and affordable tuition for international students.",
            "Denmark's strong economy, English-taught programs, and focus on sustainability and innovation make it an attractive destination for students seeking cutting-edge education and career opportunities."
        ],
    },
    highlights: [
        {
            icon: "fas fa-city",
            title: "Student-friendly cities",
            description: "Copenhagen ranks among the top student cities globally, known for its high quality of life and excellent universities."
        },
        {
            icon: "fas fa-briefcase",
            title: "Post-study work rights",
            description: "Denmark offers 6 months to 2 years of post-study work opportunities for international graduates."
        },
        {
            icon: "fas fa-graduation-cap",
            title: "Top universities",
            description: "Denmark has 5 universities in the QS World University Rankings, with University of Copenhagen ranking in the top 100."
        },
        {
            icon: "fas fa-users",
            title: "Innovation focus",
            description: "Denmark's education system emphasizes innovation, sustainability, and practical learning with strong industry connections."
        }
    ],
    keyFacts: [
        { factNumber: "8", factLabel: "Universities" },
        { factNumber: "35,000", factLabel: "International Students in Denmark in 2024" },
        { factNumber: "20 Hours", factLabel: "Per week Part-time work permit" },
        { factNumber: "2 Years", factLabel: "Post-study work permit" }
    ],
    stats: {
        capital: "Copenhagen",
        poplulation: "5.9 million",
        economicGrowthRate: "2.9%",
        currency: "Danish Krone (DKK)",
        language: "Danish (English widely spoken)",
        weather: [
            "Copenhagen: 13°C - 21°C",
            "Aarhus: 12°C - 20°C",
            "Odense: 12°C - 20°C",
            "Aalborg: 11°C - 19°C"
        ]
    },
    requirements: [
        "Academic transcripts",
        "English proficiency test scores (IELTS, TOEFL, Cambridge)",
        "Motivation letter",
        "Curriculum Vitae",
        "Valid passport copy",
        "Proof of finances (Bank statements)",
        "Health insurance",
        "Portfolio (for design/arts programs)"
    ],
    intake: {
        title: "Danish universities offer two main intakes:",
        intakes: [
            {
                name: "Autumn Intake",
                month: "Starts in August/September"
            },
            {
                name: "Spring Intake",
                month: "Starts in January/February (Limited programs)"
            }
        ]
    },
    programs: [
        {
            name: "AP Degree",
            duration: "2 years"
        },
        {
            name: "Professional Bachelor",
            duration: "3-4 years"
        },
        {
            name: "Bachelor's Degree",
            duration: "3 years"
        },
        {
            name: "Master's Degree",
            duration: "2 years"
        },
        {
            name: "PhD",
            duration: "3 years"
        }
    ],
    popularPrograms: {
        title: "Denmark offers high-quality education with focus on innovation and sustainability. Popular programs for international students include:",
        programs: [
            "Engineering",
            "Business Administration",
            "Computer Science",
            "Design",
            "Environmental Science",
            "Architecture",
            "Medicine",
            "Social Sciences",
            "Renewable Energy"
        ]
    },
    costs: [
        {
            program: "Foundation/Pathway",
            local: "DKK 50,000 - 80,000",
            bdt: "6,00,000 – 9,60,000 BDT"
        },
        {
            program: "Undergraduate Courses",
            local: "DKK 45,000 - 120,000",
            bdt: "5,40,000 – 14,40,000 BDT"
        },
        {
            program: "Postgraduate Courses",
            local: "DKK 50,000 - 130,000",
            bdt: "6,00,000 – 15,60,000 BDT"
        },
        {
            program: "PhD Programs",
            local: "Free (with stipend)",
            bdt: "Free with monthly stipend"
        }
    ],
    topCities: {
        title: "Denmark offers excellent education in several vibrant cities with high quality of life. Key student cities include:",
        cities: [
            {
                name: "Copenhagen",
                description: "Capital city with top universities and vibrant cultural scene"
            },
            {
                name: "Aarhus",
                description: "Second largest city with excellent university and research facilities"
            },
            {
                name: "Odense",
                description: "Historic city with growing university presence and innovation focus"
            },
            {
                name: "Aalborg",
                description: "Northern city with strong engineering and technical programs"
            },
            {
                name: "Esbjerg",
                description: "Coastal city with maritime and energy programs"
            },
            {
                name: "Roskilde",
                description: "University town with focus on social sciences and humanities"
            }
        ]
    },
    workOptions: {
        partTimeWork: "International students can work up to 20 hours per week during study periods and full-time during breaks. Students typically earn DKK 120-200 per hour. The work experience in Denmark's innovative companies can be highly valuable.",
        postStudyWork: "The Establishment Card allows graduates to stay and work in Denmark for 6 months to 2 years after graduation. This provides an excellent opportunity to gain work experience in Denmark's strong economy and potentially qualify for permanent residency."
    },
    faqs: [
        {
            question: "How do I apply for a student visa in Denmark?",
            answer: "To apply for a student visa, you need an acceptance letter from a Danish institution, proof of English proficiency, financial capacity (DKK 6,000 per month), health insurance, and a completed visa application form. The application is processed through the Danish Immigration Service."
        },
        {
            question: "What are the English language requirements for studying in Denmark?",
            answer: "Most Danish institutions require IELTS (6.0-6.5), TOEFL (80-90), or Cambridge (B2-C1) scores. Some programs may require higher scores, especially for competitive programs."
        },
        {
            question: "Can I work while studying in Denmark?",
            answer: "Yes, international students can work up to 20 hours per week during study periods and full-time during breaks. The Establishment Card allows graduates to work after completing their studies."
        },
        {
            question: "Are scholarships available for international students in Denmark?",
            answer: "Yes, there are various scholarships offered by the Danish government, universities, and external organizations. These include the Danish Government Scholarships, university-specific scholarships, and EU/EEA mobility programs."
        },
        {
            question: "How much does it cost to study in Denmark from Bangladesh?",
            answer: "Studying in Denmark from Bangladesh costs around DKK 45,000-130,000 for tuition, DKK 6,000-8,000 per month for living expenses, and DKK 2,000-3,000 for health insurance annually. Total annual cost ranges from DKK 120,000-200,000."
        },
        {
            question: "What GPA is required to study in Denmark from Bangladesh?",
            answer: "To study in Denmark from Bangladesh, the required GPA typically ranges from <strong>3.0 to 3.5</strong> on a 4.0 scale for undergraduate programs and <strong>3.2 to 3.7</strong> for postgraduate programs, depending on the university and program competitiveness."
        }
    ]
}
